import type { IconSvgObject } from './types';

const PlaxoIcon: IconSvgObject = [
  ["path", { d: "M10 16.584C10.6125 16.8516 11.2889 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12V20.6622C4.01099 18.9331 2 15.7014 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C11.3151 22 10.6462 21.9311 10 21.8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default PlaxoIcon;
